import { Icon, IconSize } from '@teetsh/app/src/components/Icons/icon';

export type Intent =
  | 'primary'
  | 'danger'
  | 'none'
  | 'success'
  | 'empty'
  | 'warning'
  | 'dark';

export type RefreshedIntent =
  | 'brand'
  | 'neutral'
  | 'danger'
  | 'warning'
  | 'positive';

export const mapIntentToRefreshedIntent: (
  intent?: Intent,
) => RefreshedIntent = intent => {
  switch (intent) {
    case 'primary':
      return 'brand';
    case 'warning':
      return 'warning';
    case 'danger':
      return 'danger';
    case 'success':
      return 'positive';
    default:
      return 'neutral';
  }
};

export interface BaseButtonProps {
  small?: boolean;
  large?: boolean;
  extralarge?: boolean;
  id?: string;
  className?: string;
  outlined?: boolean;
  fill?: boolean;
  minimal?: boolean;
  active?: boolean;
  disabled?: boolean;
  loading?: boolean;
  rightIcon?: Icon;
  icon?: Icon;
  iconSize?: IconSize;
  intent?: Intent;
  innerRef?: any;
  alignText?: 'left' | 'center' | 'right';
  children?: React.ReactNode | string;
  iconStyle?: Object;
  rightIconStyle?: Object;
}
